import { Employee } from '../employee/employee';

export class Availability {
	readonly id: string;
	employee: Employee;
	availabilityCareSkillId: number;
	weekDay: number;
	startTime: number;
	endTime: number;
}
